import { InjectionToken } from '@angular/core';

/** jQuery DI token. */
export const JQUERY = new InjectionToken('jQuery');

/** jQuery factory function. */
export function jqueryFactory(): any {
  return window['jQuery'];
}
